import React from "react";
import TextInput from "../../Components/Inputs/TextInput";

export default function ({ register, errors, control, data, watch }) {

    return (
        <>
            <TextInput
                label="Name"
                name="name"
                parentClasses="col-md-12"
                register={register}
                required={true}
                errorMessage={errors?.name}
            />
        </>
    );
}